"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __importStar(require("@gin-betting/core"));
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var _a = core_1.default.entities.constants, GROUP_GET_MATCHES_REQUEST = _a.GROUP_GET_MATCHES_REQUEST, GROUP_GET_MATCHES_SUCCESS = _a.GROUP_GET_MATCHES_SUCCESS, GROUP_GET_MATCHES_FAIL = _a.GROUP_GET_MATCHES_FAIL, DELETE_MATCH_ID = _a.DELETE_MATCH_ID, MATCH_ENDED = _a.MATCH_ENDED, STORE_NORMALIZED_ENTITIES = _a.STORE_NORMALIZED_ENTITIES;
var DefaultMatchListCategory = immutable_1.Record({
    matchIds: immutable_1.OrderedSet(),
    fetchStatus: core_1.App.FetchStatus.INITIAL,
    prepend: false,
    customInitialLoad: false,
}, constants_1.MATCH_LIST_CATEGORY_RECORD_NAME);
var handleActionByMetaGroup = function (action, state, matchesLimitPerPage) {
    if (!action.meta.group) {
        return null;
    }
    switch (action.meta.group) {
        case GROUP_GET_MATCHES_REQUEST: {
            var _a = action.payload.args, listType = _a.listType, isPolling = _a.isPolling, isLoadMore = _a.isLoadMore, requestId = _a.requestId, _b = _a.prepend, prepend = _b === void 0 ? false : _b, _c = _a.customInitialLoad, customInitialLoad = _c === void 0 ? false : _c;
            if (!listType || !requestId)
                return state;
            if (isPolling) {
                return state.set('requestId', requestId);
            }
            var categoryName = listType;
            var category = state.get(categoryName);
            if (!category)
                return state;
            var newList = listType === core_1.App.Routes.TOURNAMENT && !isPolling && !isLoadMore // first load
                ? immutable_1.OrderedSet()
                : category.matchIds;
            var nextCategory = category
                .set('fetchStatus', core_1.App.FetchStatus.LOADING)
                .set('prepend', prepend)
                .set('customInitialLoad', customInitialLoad)
                .set('matchIds', newList);
            return state
                .set(categoryName, nextCategory)
                .set('requestId', requestId);
        }
        case GROUP_GET_MATCHES_SUCCESS: {
            var _d = action.payload, result = _d.result, listType = _d.listType, isLoadMore = _d.isLoadMore, requestId = _d.requestId;
            if (!listType ||
                (requestId && requestId !== state.requestId) ||
                !result) {
                return state;
            }
            var categoryName = listType;
            var category = state.get(categoryName);
            if (!category)
                return state;
            /* for initial load we have to receive two pages at least
            if we receive only one page instead of two expected - nothing must be shown */
            var validatedResult = category.customInitialLoad &&
                result.length <= matchesLimitPerPage
                ? []
                : result;
            var newMatchIds = immutable_1.OrderedSet(validatedResult);
            /* as long as polling will not cover every fetched page
            (currently - only few pages in the very beginning of the matches list)
            should replace matches for initial load or  retrieving same data */
            var nextMatchIds = newMatchIds;
            if (!category.customInitialLoad && isLoadMore) {
                /* no replacing, need to merge */
                nextMatchIds = category.prepend
                    ? newMatchIds.merge(category.matchIds)
                    : category.matchIds.merge(newMatchIds);
            }
            /* in case empty result.length and customInitialLoad == false
            should not drop customInitialLoad */
            var newCustomInitialLoad = category.customInitialLoad && lodash_1.isEmpty(validatedResult);
            var topMarketIdsMapping = state.get('topMarketIdsMapping');
            var nextTopMarketIdsMapping = utils_1.getNextTopMarketIdsMapping(action, topMarketIdsMapping);
            var nextCategory = category
                .set('matchIds', nextMatchIds)
                .set('fetchStatus', core_1.App.FetchStatus.LOADED)
                .set('prepend', false)
                .set('customInitialLoad', newCustomInitialLoad);
            return state
                .set(categoryName, nextCategory)
                .set('topMarketIdsMapping', nextTopMarketIdsMapping)
                .set('requestId', null);
        }
        case GROUP_GET_MATCHES_FAIL: {
            var _e = action.payload, listType = _e.listType, args = _e.args;
            var requestId = args.requestId;
            if (!listType ||
                !requestId ||
                requestId !== state.get('requestId')) {
                return state;
            }
            var categoryName = listType;
            var category = state.get(categoryName);
            if (!category)
                return state;
            var nextCategory = category.set('fetchStatus', core_1.App.FetchStatus.FAILED);
            return state.set(categoryName, nextCategory).set('requestId', null);
        }
        // TODO: check case when we need to handle action by action.type and action.group.type
        default:
            return state;
    }
};
function makeMatchListReducer(matchesLimitPerPage, routes) {
    var mapping = lodash_1.transform(routes, function (acc, i) {
        acc[i] = new DefaultMatchListCategory();
    }, {});
    var MatchListStateRecord = immutable_1.Record(__assign({ topMarketIdsMapping: immutable_1.Map(), requestId: null }, mapping), 'MatchListState');
    var initialState = new MatchListStateRecord();
    return function (inState, action) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (inState === void 0) { inState = initialState; }
        var state = inState;
        if (((_b = (_a = action.meta) === null || _a === void 0 ? void 0 : _a.requestAction) === null || _b === void 0 ? void 0 : _b.isTopMarkets) ||
            ((_c = action.meta) === null || _c === void 0 ? void 0 : _c.isTopMarkets) ||
            ((_g = (_f = (_e = (_d = action.meta) === null || _d === void 0 ? void 0 : _d.requestAction) === null || _e === void 0 ? void 0 : _e.payload) === null || _f === void 0 ? void 0 : _f.variables) === null || _g === void 0 ? void 0 : _g.isTopMarkets)) {
            state = utils_1.setTopMarkets(state, action);
        }
        if (action.meta) {
            var result = handleActionByMetaGroup(action, state, matchesLimitPerPage);
            if (result !== null)
                return result;
        }
        switch (action.type) {
            case constants_1.GET_FAVORITE_MATCHES_SUCCESS: {
                var topMarketIdsMapping = state.get('topMarketIdsMapping');
                var nextTopMarketIdsMapping = utils_1.getNextTopMarketIdsMapping(action, topMarketIdsMapping);
                return state.set('topMarketIdsMapping', nextTopMarketIdsMapping);
            }
            case DELETE_MATCH_ID: {
                var matchId = action.payload.matchId;
                if (!matchId)
                    return state;
                return state
                    .deleteIn(['results', 'matchIds', matchId])
                    .deleteIn(['outrights', 'matchIds', matchId])
                    .deleteIn(['upcoming', 'matchIds', matchId])
                    .deleteIn([
                    'tournament',
                    'matchIds',
                    matchId,
                ]);
            }
            case MATCH_ENDED: {
                var matchId = action.payload.matchId;
                return state
                    .deleteIn(['upcoming', 'matchIds', matchId])
                    .deleteIn([
                    'tournament',
                    'matchIds',
                    matchId,
                ]);
            }
            case STORE_NORMALIZED_ENTITIES: {
                var isTopMarkets = action.meta.isTopMarkets;
                if (!isTopMarkets)
                    return state;
                return utils_1.setTopMarkets(state, action);
            }
            case constants_1.RESET_MATCHES_CATEGORY: {
                var listType = action.payload.listType;
                var categoryName = listType;
                var category = state.get(categoryName);
                if (!category)
                    return state;
                var nextCategory = category
                    .set('matchIds', category.get('matchIds').clear())
                    .set('fetchStatus', core_1.App.FetchStatus.INITIAL);
                return state.set(categoryName, nextCategory);
            }
            default:
                return state;
        }
    };
}
exports.default = makeMatchListReducer;
//# sourceMappingURL=reducer.js.map